import { useMemo } from 'react'
import { THEMES } from './themes.js'

export default function EgoQuoteBanner({ theme }) {
  const t = THEMES[theme] || THEMES.hunter
  const quote = useMemo(() => {
    const idx = Math.floor((new Date().getDate() + new Date().getMonth()) % t.quotes.length)
    return t.quotes[idx]
  }, [t.quotes])

  return (
    <div className="border-y border-card py-3 text-center">
      <div className="font-display text-xs tracking-[0.3em] opacity-60 uppercase">{t.tagline}</div>
      <div className="mt-1 italic opacity-90 text-accent">“{quote}”</div>
    </div>
  )
}
